<script>
  import ToggleSwitch from "../widgets/ToggleSwitch.vue";
  import TableParticipants from "./TableParticipants.vue";
  import ResultsVue from "./Results/Results.vue";
  import Awards from "./Awards.vue";
  import PolicyUsersViewVue from "./PolicyCompetitions/PolicyUsersView.vue";
  import { mapActions, mapGetters, mapMutations } from "vuex";

  export default {
    name: "createCompetition",
    props: ["competitionsTypes"],
    components: {
      ToggleSwitch,
      TableParticipants,
      Awards,
      ResultsVue,
      PolicyUsersViewVue,
    },
    data() {
      return {
        title: "",
        searchModels: "",
        askComponentsInfo: [0],
        sectionStatus: {
          settings: true,
          results: false,
        },
        section2Status: {
          awards: false,
          settings: true,
        },
        formAction: "post",
        isChecked: true,
        allChecked: false,
        awrdsRangeChecked: false,
        loading: false,
        startDate: "",
        endDate: "",
        startDateTime: "",
        endDateTime: "",
        formData: {
          name: "",
          description: "",
          statusModelsAll: "",
          visualModelsCount: 0,
          dataModelsSelect: [],
          selectedHourInit: "",
          selectedHourEnd: "",
          showTop: 0,
          totalPodium: 3,
          typeScore: "",
          showInNews: false,
          maxShows: 1,
          typeContest: "",
        },
        awardsList: [],
        hourTimeList: [],
        statusSelected: "pending",
        dicStatus: {
          pending: "Pendiente",
          active: "Activo",
          inactive: "Inactivo",
          finished: "Finalizado",
        },
        statusAvailable: ["pending", "active", "finished", "inactive"],
        arrTypes: [
          { name: "Por votos", value: "vote", statusInternal: false, statusExternal: false, disabledInternal: true, disabledExternal: true },
          { name: "Por tips", value: "tip", statusInternal: false, statusExternal: false, disabledInternal: false, disabledExternal: true },
          { name: "Por posición", value: "position", statusInternal: false, statusExternal: false, disabledInternal: false, disabledExternal: true },
        ],
        usersDb: [],
        showPolitics: false,
        showScoreType: false,
        rankingMode: "manual",
        rankingLimit: 30,
        rankingScheduledTimes: [],
        rankingSelectedHour: "",
        rankingDropdownOpen: false,
      };
    },
    computed: {
      ...mapGetters("competitions", ["getCompetitions", "getCompetition", "getParticipants"]),
      ...mapGetters("user", ["getOrderUsersByArea"]),
      modelsToSelect() {
        const search = this.searchModels.toLowerCase();
        const models = this.getOrderUsersByArea.filter((ele) => ele.name === "modelos");

        return models[0]?.users.filter((model) => {
          const { user, city, artisticName, office } = model;

          const includesUser = this.verifyIncudeInDate(user, search);
          const includesCity = this.verifyIncudeInDate(city, search);
          const includesArtisticName = this.verifyIncudeInDate(artisticName, search);
          const includesOffice = this.verifyIncudeInDate(office, search);

          return includesUser || includesCity || includesArtisticName || includesOffice;
        });
      },
      getMonitors() {
        return this.getOrderUsersByArea.filter(({ name }) => name === "monitores");
      },
      showSearch() {
        return this.section2Status.settings && this.$screen.width > 550;
      },
      availableStatus() {
        if (!this.isEdit) {
          return ["pending"];
        }

        return this.statusAvailable || [];
      },
      startDateFormat() {
        return this.createDateString(this.startDate, this.startDateTime);
      },
      endDateFormat() {
        return this.createDateString(this.endDate, this.endDateTime);
      },
      competitionId() {
        return this.$route.params?.id;
      },
      isEdit() {
        return !!this.competitionId;
      },
      isFinished() {
        return ["finished", "inactive"].includes(this.getCompetition?.status);
      },
      selectContest() {
        const constestReturn = this.competitionsTypes.find((contest) => contest.type === this.formData.typeContest);
        if (!constestReturn) return {};
        return { ...constestReturn, rankingMode: this.rankingMode };
      },
    },
    watch: {
      competitionId() {
        this.changeDataCompetition();
      },
    },
    methods: {
      ...mapActions("competitions", ["createNewCompetition", "updateCompetition", "getCompetitionById", "activeAllParticipants"]),
      ...mapActions("user", ["orderUsersAreas"]),
      ...mapMutations("competitions", ["setUsersSelecetedView", "setUsersSelectedInteractive", "setUsersSelecetedReset", "setCompetition"]),
      ...mapActions("competitions", ["updateCompetitionParticipant"]),
      setDate(key) {
        const currentDate = new Date();
        const newvalueDate = new Date(this[`${key}Format`]);

        if (newvalueDate < currentDate) {
          currentDate.setHours(currentDate.getHours() + 1, 0, 0, 0);
          this.setFullDates(currentDate, key);
        }

        if (!this[`${key}Time`]) {
          const dateToTime = new Date(this[`${key}Format`]);
          const hours = dateToTime.getHours();
          this[`${key}Time`] = `${hours < 10 ? "0" : ""}${hours}:00`;
        }

        if (this.startDateFormat && this.endDateFormat && new Date(this.startDateFormat) >= new Date(this.endDateFormat)) {
          const dateFormat = new Date(this.startDateFormat);
          dateFormat.setHours(dateFormat.getHours() + 1);
          this.setFullDates(dateFormat, "endDate");
        }

        if (!this.isEdit) {
          this.sendCreateUpdate();
          return;
        }

        this.updateDates();
      },
      setFullDates(dateInit, key) {
        this[key] = dateInit.toISOString().split("T")[0];
        const hours = dateInit.getHours();
        this[`${key}Time`] = `${hours < 10 ? "0" : ""}${hours}:00`;
      },
      async updateDates() {
        if ((!this.endDateFormat && !this.startDateFormat) || this.loading) {
          return;
        }

        const body = {};

        if (this.endDateFormat) {
          body.endDate = this.endDateFormat;
        }
        if (this.startDateFormat) {
          body.startDate = this.startDateFormat;
        }

        await this.sendUpdateData(body);
      },
      createDateString(dateFull, dateTime) {
        if (!dateFull) {
          return "";
        }

        const date = `${dateFull}T${dateTime || "00:00:00"}`;
        const dateObj = new Date(date);

        return dateObj.toISOString();
      },
      initData(comp) {
        this.formData.typeScore = comp.typeScore;
        this.formData.status = comp.status;
        this.formData.name = comp.name;
        this.formData.description = comp.description;
        this.formData.showTop = comp.showTop;
        this.formData.showInNews = comp.showInNews;
        this.formData.totalPodium = comp.totalPodium;
        this.formData.maxShows = comp.maxShows || 3;
        this.formData.typeContest = comp?.typeContest;
        this.awrdsRangeChecked = comp?.positionByRange;
        this.showPolitics = comp?.policiesView?.users ? false : true;
        if (comp?.startDate) {
          const da1 = new Date(comp.startDate);
          this.setFullDates(da1, "startDate");
        }
        if (comp?.endDate) {
          const da1 = new Date(comp.endDate);
          this.setFullDates(da1, "endDate");
        }
        if (comp?.showTop !== 0) {
          this.isChecked = false;
        }
        this.arrTypes.map((it) => {
          if (it.value === comp.typeScore) {
            if (comp.typeContest === "internal") {
              it.statusInternal = true;
            } else {
              it.statusExternal = true;
            }
          }
        });
        this.awardsList = comp.awards;
        this.rankingMode = comp.rankingMode || "manual";
        this.rankingLimit = comp.rankingLimit || 30;
        this.rankingScheduledTimes = comp.rankingScheduledTimes ? [...comp.rankingScheduledTimes] : [];
      },
      verifyIncudeInDate(dateIn, compare) {
        const formattedDate = this.cleanString(dateIn || "");
        const formattedCompare = this.cleanString(compare);
        return formattedDate.includes(formattedCompare);
      },
      cleanString(str) {
        return str
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "")
          .toLowerCase();
      },
      generateHoursDay() {
        const horas = [];
        for (let i = 0; i < 24; i++) {
          const hora24 = i;
          const hora12 = i % 12 === 0 ? 12 : i % 12;
          const ampm = i < 12 ? "am" : "pm";
          const horaLabel = `${hora12}:00 ${ampm}`;
          const hor = hora24 < 10 ? `0${hora24}:00` : `${hora24}:00`;
          horas.push({ label: horaLabel, value: hor });
        }
        return horas;
      },
      sendCreateUpdate() {
        this.formData.showTop = this.formData.showTop < 0 ? 0 : this.formData.showTop;

        if (!this.isEdit) {
          this.sendData();
        } else {
          this.updateData();
        }
      },
      updateHours_test() {
        this.updateData();
      },
      updateTime_test(val) {
        const va = new Date(this.formData[val] + "T00:00:00");
        const currentDate = new Date(va);

        if (va < currentDate) {
          currentDate.setHours(currentDate.getHours() + 1, 0, 0, 0);
          const dateparce = currentDate.toISOString().split("T");
          this.formData[val] = dateparce.split("T")[0];
        }
        this.formData[`${val}Time`] = "06:00";
        this.updateData();
      },
      changeSection(section) {
        for (const key in this.sectionStatus) {
          this.sectionStatus[key] = key === section;
        }
      },
      changeSection2(section) {
        this.searchModels = "";

        for (const key in this.section2Status) {
          this.section2Status[key] = key === section;
        }
      },
      parseFieldsData(formUpdata) {
        let currentUpdateForm = {};
        if (this.getCompetition) {
          if (this.getCompetition.name !== formUpdata.name) {
            currentUpdateForm.name = formUpdata.name;
          }
          if (this.getCompetition.description !== formUpdata.description) {
            currentUpdateForm.description = formUpdata.description;
          }
          if (formUpdata.startDate && formUpdata.startDateTime) {
            let d1 = new Date(formUpdata.startDate + `T${formUpdata.startDateTime}:00`);
            currentUpdateForm.startDate = d1;
          }
          if (formUpdata.endDate && formUpdata.endDateTime) {
            let d1 = new Date(formUpdata.endDate + `T${formUpdata.endDateTime}:00`);
            currentUpdateForm.endDate = d1;
          }
          if (this.getCompetition.showTop !== formUpdata.showTop) {
            currentUpdateForm.showTop = formUpdata.showTop;
          }
          if (this.getCompetition.totalPodium !== formUpdata.totalPodium) {
            currentUpdateForm.totalPodium = formUpdata.totalPodium;
          }
        }
        return currentUpdateForm;
      },
      async sendData() {
        const { name, description, typeContest } = this.formData;
        if (!name || !typeContest || !this.startDateFormat) {
          return;
        }
        const formData = {
          name,
          description,
          typeContest,
          status: this.statusSelected,
          startDate: this.startDateFormat,
        };

        const newCompetition = await this.$store.dispatch("competitions/createNewCompetition", formData);

        if (newCompetition?.contest?._id) {
          this.formData._id = newCompetition.contest._id;
          this.$toast.success("Concurso creado");

          this.$router.push(`/competition/editCompetition/${newCompetition.contest._id}`).catch(() => {});
        }
      },
      async updateData() {
        const formJson = this.parseFieldsData(this.formData);
        await this.sendUpdateData(formJson);
      },
      async sendUpdateData(body) {
        this.loading = true;
        const updateCompetition = await this.$store.dispatch("competitions/updateCompetition", { newCompetition: body, _id: this.$route.params.id });
        const { error } = updateCompetition;

        if (error) {
          this.$toast.error(error);
          return;
        } else {
          this.$toast.success("Actualizando", { timeout: 4000 });
          await this.getCompetitionById({ _id: this.$route.params.id });
          this.initData(this.getCompetition);
        }

        this.loading = false;
      },
      async updateStatus() {
        await this.sendUpdateData({ status: this.statusSelected });
      },
      async changeTypeUpdate(event, type, obj, idx) {
        event.preventDefault();

        this.arrTypes.map((it, index) => {
          it.statusExternal = false;
          it.statusInternal = false;
          if (type === "internal" && idx === index) {
            it.statusInternal = true;
          } else if (type === "external" && idx === index) {
            it.statusExternal = true;
          }
        });

        await this.sendUpdateData({ typeContest: type, typeScore: obj.value });
      },
      changeShowTop(event) {
        const isChecked = event.srcElement.checked ? true : false;
        this.isChecked = isChecked;
        if (isChecked) {
          this.formData.showTop = 0;
        }
        this.sendCreateUpdate();
      },
      async handleShowPoliticsForAll(event) {
        this.showPolitics = event.srcElement.checked;
        await this.sendUpdateData({ policiesView: { users: this.showPolitics ? null : [] }, policiesInteration: { users: this.showPolitics ? null : [] } });
      },
      async handleChangeContestType(value) {
        await this.sendUpdateData({ typeContest: value });
      },
      async activeAllPartic(event) {
        const isChecked = event.srcElement.checked ? true : false;
        this.allChecked = isChecked;
        let action = isChecked ? "active" : "disable";
        const resp = await this.$store.dispatch("competitions/activeAllParticipants", { idContest: this.$route.params.id, actionParticipants: action });
        if (resp) {
          this.$toast.success("Actualizando");
          if (!isChecked) {
            this.$refs.participantsTable.clearData();
          } else {
            this.$refs.participantsTable.initData();
          }
        } else {
          this.$toast.error("Error");
        }
      },
      async activeRange(event) {
        const isChecked = event.srcElement.checked ? true : false;
        this.awrdsRangeChecked = isChecked;
        await this.sendUpdateData({ positionByRange: isChecked });
      },
      async updShowInNews(event) {
        const isChecked = !!event.srcElement?.checked;
        this.formData.showInNews = isChecked;
        await this.sendUpdateData({ showInNews: isChecked });
      },
      options() {
        this.usersDb = this.getOrderUsersByArea.map((area) => area.users).flat(Infinity);
      },
      initialDataBypolicies() {
        const dataView = this.getCompetition.policiesView?.users ? this.getCompetition.policiesView.users : [];
        const dataInteraction = this.getCompetition.policiesInteration?.users ? this.getCompetition.policiesInteration.users : [];

        const applyData = (data, setterFunction) => {
          data
            .map((user) => this.usersDb.find((ele) => ele._id === user))
            .filter((userFind) => userFind)
            .forEach((userFind) => setterFunction(userFind));
        };

        applyData(dataView, this.setUsersSelecetedView.bind(this));
        applyData(dataInteraction, this.setUsersSelectedInteractive.bind(this));
      },
      async changeDataCompetition() {
        if (!this.isEdit) {
          this.setCompetition({});
          this.statusSelected = "pending";
        } else {
          await this.getCompetitionById({ _id: this.$route.params.id });
          this.statusSelected = this.getCompetition.status;
        }

        this.initData(this.getCompetition);
      },
      async showNewsletter(e) {
        this.formData.maxShows = parseInt(e.target.value);
        await this.sendUpdateData({ maxShows: parseInt(e.target.value) });
      },
      async handleRankingModeChange(mode) {
        this.rankingMode = mode;
        if (mode === "manual") {
          await this.sendUpdateData({ rankingMode: "manual" });
        } else {
          const limit = Math.min(500, Math.max(1, this.rankingLimit || 30));
          this.rankingLimit = limit;
          await this.sendUpdateData({
            rankingMode: "automatic",
            rankingScheduledTimes: this.rankingScheduledTimes,
            rankingLimit: limit,
          });
        }
      },
      async addRankingHour() {
        if (!this.rankingSelectedHour || this.rankingScheduledTimes.includes(this.rankingSelectedHour)) return;
        this.rankingScheduledTimes.push(this.rankingSelectedHour);
        this.rankingScheduledTimes.sort();
        this.rankingSelectedHour = "";
        await this.saveRankingSchedule();
      },
      async removeRankingHour(hour) {
        this.rankingScheduledTimes = this.rankingScheduledTimes.filter((h) => h !== hour);
        if (this.rankingScheduledTimes.length > 0) {
          await this.saveRankingSchedule();
        }
      },
      closeRankingDropdown(e) {
        if (!this.$refs.rankingDropdown?.contains(e.target)) {
          this.rankingDropdownOpen = false;
        }
      },
      selectRankingHour(value) {
        this.rankingSelectedHour = value;
        this.rankingDropdownOpen = false;
      },
      async saveRankingSchedule() {
        if (this.rankingScheduledTimes.length === 0) {
          this.$toast.error("Debe agregar al menos un horario");
          return;
        }
        const limit = Math.min(500, Math.max(1, this.rankingLimit || 30));
        this.rankingLimit = limit;
        await this.sendUpdateData({
          rankingMode: "automatic",
          rankingScheduledTimes: this.rankingScheduledTimes,
          rankingLimit: limit,
        });
      },
    },
    async mounted() {
      await this.setUsersSelecetedReset();
      await this.orderUsersAreas();

      this.options();
      this.initialDataBypolicies();
      this.changeDataCompetition();

      this.hourTimeList = this.generateHoursDay();
      document.addEventListener("click", this.closeRankingDropdown);
    },
    beforeDestroy() {
      document.removeEventListener("click", this.closeRankingDropdown);
    },
  };
</script>

<template>
  <div class="create">
    <div class="create__option" v-if="isEdit">
      <p :class="sectionStatus.settings ? 'select' : 'create__option--item-active'" @click="changeSection('settings')">Configuración</p>
      <p :class="sectionStatus.results ? 'select' : 'create__option--item-active'" @click="changeSection('results')">Resultados</p>
    </div>
    <form v-if="sectionStatus.settings" class="formCompetition" id="competition">
      <div v-show="sectionStatus.settings">
        <div class="create__name">
          <div class="create__name--container">
            <label for="title" class="create__name--label">Titulo</label>
            <input
              class="create__name--input"
              id="nombre"
              type="text"
              placeholder="Nombre del concurso"
              @focusout="sendCreateUpdate"
              name="title"
              v-model="formData.name"
              :disabled="isFinished"
              required />
          </div>
          <div class="create__name--container">
            <label for="description" class="create__name--label">Subtitulo</label>
            <input
              class="create__name--input"
              id="description"
              name="description"
              type="text"
              placeholder="Subtitulo"
              @focusout="sendCreateUpdate"
              v-model="formData.description"
              :disabled="isFinished"
              required />
          </div>
          <div class="create__name--selectContainer">
            <label for="vista" class="create__name--label">Mostrar animacion de subtitulo:</label>
            <select class="create__name--select" name="maxShows" id="vista" v-model="formData.maxShows" @change="showNewsletter">
              <option v-for="number in 10" :key="number" :value="number">
                {{ number }}
              </option>
            </select>
            <div class="create__name--selectSubtitle">cantidad de veces</div>
          </div>
          <div class="create__name--contestType">
            <label for="vista" class="create__name--label">Tipo de concurso:</label>
            <div class="create__contestTypeOption" v-for="(type, index) in competitionsTypes" :key="index">
              <input
                class="create__contestOption mycheck"
                type="radio"
                :id="type.type"
                :value="type.type"
                @click="() => isEdit && handleChangeContestType(type.type)"
                v-model="formData.typeContest"
                required />
              <label :for="type.type">{{ type.name }}</label>
            </div>
          </div>
          <div class="create__contestInfo" v-if="selectContest?.messageAlert">
            <iconic name="informationIcon"></iconic>
            <p>{{ selectContest?.messageAlert }}</p>
          </div>
        </div>
        <div class="create__programmer">
          <div class="create__programmerHeader">
            <p class="create__programmer--title">Cronograma de concurso</p>
            <select class="create__filterUser" v-model="statusSelected" @change="updateStatus" :disabled="!isEdit || !availableStatus.length">
              <option :value="status" v-for="(status, idx) in availableStatus" :key="idx">{{ dicStatus[status] }}</option>
            </select>
          </div>
          <div class="create__programmer--timer">
            <div class="create__programmer--seccion">
              <div class="create__programmer--calendar">
                <iconic name="calendar"></iconic>
                <p>Fecha inicial</p>
              </div>
              <div>
                <input @change="setDate('startDate')" v-model="startDate" :disabled="isFinished" type="date" name="dateInit" class="create__programmer--date" />
              </div>
            </div>
            <div class="create__programmer--seccion">
              <div class="create__programmer--clock">
                <iconic name="clock_regular"></iconic>
                <p>Hora inicio</p>
              </div>
              <div>
                <select @change="setDate('startDate')" v-model="startDateTime" :disabled="!startDate || isFinished" class="create__programmer--time">
                  <option value="">Seleccionar hora</option>
                  <option v-for="(hour, index) in hourTimeList" :value="hour.value" :key="index">{{ hour.label }}</option>
                </select>
              </div>
            </div>
            <div class="create__programmer--seccion">
              <div class="create__programmer--calendar">
                <iconic name="calendar"></iconic>
                <p>Fecha final</p>
              </div>
              <div>
                <input @change="setDate('endDate')" v-model="endDate" :disabled="!isEdit || isFinished" type="date" name="endDate" class="create__programmer--date" />
              </div>
            </div>
            <div class="create__programmer--seccion">
              <div class="create__programmer--clock">
                <iconic name="clock_regular"></iconic>
                <p>Hora final</p>
              </div>
              <div>
                <select @change="setDate('endDate')" v-model="endDateTime" :disabled="!endDate || isFinished" class="create__programmer--time">
                  <option value="">Seleccionar hora</option>
                  <option v-for="(hour, index) in hourTimeList" :value="hour.value" :key="index">{{ hour.label }}</option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <template v-if="isEdit">
          <div class="create__programmer" v-if="!isFinished">
            <p class="create__programmer--title">Actualización del ranking</p>
            <div class="create__programmer--timer">
              <div class="create__contestTypeOption">
                <input class="create__contestOption mycheck" type="radio" id="rankingManual" value="manual" v-model="rankingMode" @change="handleRankingModeChange('manual')" />
                <label for="rankingManual">Manual</label>
              </div>
              <div class="create__contestTypeOption">
                <input class="create__contestOption mycheck" type="radio" id="rankingAutomatic" value="automatic" v-model="rankingMode" @change="handleRankingModeChange('automatic')" />
                <label for="rankingAutomatic">Automático</label>
              </div>
            </div>
            <template v-if="rankingMode === 'automatic'">
              <div class="create__programmer--line" />
              <div class="create__programmer--podium">
                <div>
                  <p class="create__programmer--title">Participantes del ranking</p>
                  <p class="create__programmer--subtitle">Número de participantes que se obtendrán desde estadísticas para construir el ranking.</p>
                </div>
                <input class="create__rankingLimit" type="number" min="1" max="500" v-model.number="rankingLimit" @change="saveRankingSchedule" />
              </div>
              <div class="create__programmer--line" />
              <p class="create__programmer--title">Horarios de sincronización</p>
              <p class="create__programmer--subtitle">Define las horas en las que el sistema actualizará automáticamente el ranking desde estadísticas.</p>
              <div class="create__rankingTimes">
                <div class="create__rankingTimesAdd">
                  <div class="create__rankingTimesDropdown" ref="rankingDropdown">
                    <button type="button" class="create__rankingTimesDropdownBtn" @click="rankingDropdownOpen = !rankingDropdownOpen">
                      <span>{{ rankingSelectedHour ? hourTimeList.find((h) => h.value === rankingSelectedHour)?.label : "Seleccionar hora" }}</span>
                      <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1 1l4 4 4-4" stroke="#5b5957" stroke-width="1.5" stroke-linecap="round" />
                      </svg>
                    </button>
                    <ul class="create__rankingTimesDropdownList" v-show="rankingDropdownOpen">
                      <li class="create__rankingTimesDropdownItem create__rankingTimesDropdownItem--placeholder" @click="selectRankingHour('')" disabled>Seleccionar hora</li>
                      <li class="create__rankingTimesDropdownItem" v-for="(hour, index) in hourTimeList" :key="index" @click="selectRankingHour(hour.value)">{{ hour.label }}</li>
                    </ul>
                  </div>
                  <button class="create__rankingTimesBtn" type="button" @click="addRankingHour" :disabled="!rankingSelectedHour">Agregar</button>
                </div>
                <div class="create__rankingTimesList">
                  <div class="create__rankingTimesChip" v-for="hour in rankingScheduledTimes" :key="hour">
                    <span>{{ hour }}</span>
                    <button type="button" @click="removeRankingHour(hour)" class="create__rankingTimesRemove">&times;</button>
                  </div>
                  <p v-if="rankingScheduledTimes.length === 0" class="create__rankingTimesEmpty">Sin horarios, agrega al menos uno.</p>
                </div>
              </div>
            </template>
          </div>
          <div class="create__programmer">
            <p class="create__programmer--title">Visualizacion de participantes</p>
            <p class="create__programmer--subtitle">Cantidad de participantes a visualizar</p>
            <div class="create__programmer--timer">
              <div class="create__programmer--seccion--positions">
                <div class="create__programmer--seccion--positions--label">
                  <p class="create__programmer--text">Todos los participantes</p>
                </div>
                <div class="create__programmer--seccion--positions--button">
                  <div class="create__toggle__section">
                    <ToggleSwitch :checked="isChecked" @change="($event) => changeShowTop($event)" :disabled="!isEdit" ref="toggle" class="toggle" />
                    <div class="create__viewListParticipant">
                      <p>Primeras</p>
                      <input
                        :disabled="isChecked"
                        class="create__name--inputPosition"
                        id="number"
                        type="number"
                        placeholder="0"
                        @change="sendCreateUpdate"
                        name="positions"
                        v-model="formData.showTop"
                        required />
                      <p>Posiciones</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="create__programmer--line" />
            <div class="create__programmer--podium">
              <div>
                <p class="create__programmer--title">Visualizacion podio</p>
                <p class="create__programmer--subtitle">Cantidad de posiciones en el slider principal</p>
              </div>
              <div class="create__programmer--selectAmount">
                <div class="create__programmer--option">
                  <input class="mycheck" type="radio" id="option1" value="3" @change="sendCreateUpdate" v-model="formData.totalPodium" required />
                  <label for="option1">3</label>
                </div>
                <div class="create__programmer--option">
                  <input class="mycheck" type="radio" id="option3" value="5" @change="sendCreateUpdate" v-model="formData.totalPodium" required />
                  <label for="option3">5</label>
                </div>
              </div>
            </div>
            <div class="create__programmer--line" />
            <div class="create__programmer--podium">
              <div>
                <p class="create__programmer--title">Visualizacion en Noticias</p>
                <p class="create__programmer--subtitle">Se verá el podio en la vista de noticias</p>
              </div>
              <ToggleSwitch :checked="formData.showInNews" @change="($event) => updShowInNews($event)" :disabled="!isEdit" ref="toggle" class="toggle" />
            </div>
          </div>
          <div class="create__programmer" v-if="!isFinished && showScoreType">
            <div class="create__programmer__type create__programmer__type--headers">
              <div class="create__programmer__type--title">Tipo de puntuación</div>
              <div class="create__programmer__type--internal type--border">Interno</div>
              <div class="create__programmer__type--external">Externo</div>
            </div>
            <div class="create__programmer__type create__programmer__type--body" v-for="(type, index) in arrTypes" :key="index">
              <div class="create__programmer__type--title">{{ type.name }}</div>
              <div class="create__programmer__type--internal">
                <ToggleSwitch
                  :disabled="type.disabledInternal || !isEdit"
                  :checked="arrTypes[index].statusInternal"
                  @change="($event) => changeTypeUpdate($event, 'internal', type, index)"
                  ref="toggle" />
              </div>
              <div class="create__programmer__type--external">
                <ToggleSwitch
                  :disabled="type.disabledExternal || !isEdit"
                  :checked="arrTypes[index].statusExternal"
                  @change="($event) => changeTypeUpdate($event, 'external', type, index)"
                  ref="toggle" />
              </div>
            </div>
          </div>
          <div class="create__policiesCompetitions">
            <div class="create__policiesCompetitionsHeader">
              <p class="create__policiesCompetitionsTitle">Politicas</p>
              <div class="create__policiesCompetitionsInfoMessage" v-if="showPolitics">
                <iconic name="informationIcon"></iconic>
                <p>Ahora todos los usuarios podran visualizar y comentar el concurso</p>
              </div>
              <div class="create__policiesCompetitionsAllOption">
                <p>Habilitar para todos</p>
                <ToggleSwitch :checked="showPolitics" @change="(evt) => handleShowPoliticsForAll(evt)" ref="toggle" />
              </div>
            </div>
            <PolicyUsersViewVue :users="usersDb" v-if="!showPolitics" />
          </div>
          <div class="create__programmer" v-if="!isFinished">
            <div class="create__optionWrapper">
              <div class="create__option">
                <p :class="section2Status.settings ? 'select' : 'create__option--item-active'" @click="changeSection2('settings')">Participantes</p>
                <p :class="section2Status.awards ? 'select' : 'create__option--item-active'" @click="changeSection2('awards')">Premios</p>
              </div>
              <div v-show="section2Status.settings" class="create__programmer__allParticipants" >
                <div class="create__programmer__allParticipants--toggle">
                  <span v-if="rankingMode !== 'automatic'">Activar todos</span>
                  <ToggleSwitch class="toggleSwitch" :checked="allChecked" @change="($event) => activeAllPartic($event)" :disabled="!isEdit" ref="toggle" v-if="rankingMode !== 'automatic'" />
                  <div class="create__wrapper" v-if="showSearch">
                    <input class="create__filterModel" type="text" placeholder="Buscar modelo" v-model="searchModels" />
                    <iconic name="icon_search"></iconic>
                  </div>
                </div>
              </div>
              <div v-show="section2Status.awards" class="create__programmer__allParticipants">
                <div class="create__programmer__allParticipants--toggle">
                  <span>Definir rango</span>
                  <ToggleSwitch class="toggle" :checked="awrdsRangeChecked" @change="($event) => activeRange($event)" :disabled="!isEdit" ref="toggle" />
                </div>
              </div>
            </div>
            <div v-show="section2Status.settings">
              <TableParticipants
                :contest="selectContest"
                ref="participantsTable"
                @select="sendCreateUpdate()"
                :dataModels="modelsToSelect"
                :statusRegister="!isEdit"
                :monitors="getMonitors"></TableParticipants>
            </div>
            <div v-show="section2Status.awards">
              <Awards :awardsData="awardsList" :statusRegister="!isEdit" :statusRange="awrdsRangeChecked" :dataModels="modelsToSelect"></Awards>
            </div>
          </div>
        </template>
      </div>
    </form>
    <ResultsVue v-else />
  </div>
</template>

<style lang="scss">
  .create {
    position: relative;
    min-height: 100vh;
    width: 100%;
    &__toggle__section {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 50%;
    }
    &__viewListParticipant {
      @include Flex(row, space-between);
      padding-left: 25px;
      border-left: 1px solid #d8d8d8;
    }
    &__optionWrapper {
      @include Flex(row, space-between);
      flex-wrap: wrap;
      width: 100%;
      border-bottom: 1px solid #d8d8d8;
    }
    &__filterUser {
      height: 29px;
      padding: 0 5px;
      border: 1px solid $alto;
      border-radius: 6px;
    }
    &__wrapper {
      position: relative;
      display: inline-block;
      .iconic {
        position: absolute;
        top: 50%;
        left: 8px;
        transform: translateY(-50%);
      }
    }
    &__filterModel {
      height: 35px;
      width: 277px;
      padding: 10px 16px 10px 30px;
      align-items: center;
      border: 1px solid #e5e5e5;
      border-radius: 22px;
    }
    &__option {
      @include Flex();
      .select {
        padding: 10px;
        color: $primary-color;
        font-weight: 600;
        font-size: 14px;
        border-bottom: 2px solid $primary-color;
      }

      &--item-active {
        padding: 10px 0;
        margin-right: 10px;
        font-size: 14px;

        &:hover {
          cursor: pointer;
          color: $primary-color;
          font-weight: 600;
        }
      }

      &--item-inactive {
        padding: 10px 0;
        margin-right: 10px;
        font-size: 14px;
        color: #6c757d;

        &:hover {
          cursor: no-drop;
          font-weight: 600;
        }
      }
    }
    &__contestTypeOption {
      @include Flex(row, space-between);
      gap: 10px;
    }
    &__contestOption {
      width: 20px;
      height: 20px;
      border-radius: 50%;
      border: solid 1.5px $chicago;
      &:checked {
        background-color: $primary-color;
        border-color: $primary-color;
      }
    }
    &__contestInfo {
      @include Flex(row, flex-start);
      gap: 10px;
      margin-top: $space-4;
    }
    &__name {
      width: 100%;
      max-width: 1440px;
      margin-top: 1rem;
      border-radius: 6px;
      background-color: #fff;
      padding: 15px 20px 20px 20px;
      box-shadow: 0px 0.5px 4px 0px rgba(0, 0, 0, 0.25);

      &--container {
        height: 65px;
        margin: 2px 0;
      }
      &--contestType {
        @include Flex(column, flex-start, flex-start);
        gap: 10px;
        margin-top: $space-6;
      }
      &--selectContainer {
        @include Flex(row, flex-start);
      }
      &--select {
        max-width: 50px;
        width: 100%;
        border-radius: 5px;
        border: 1px solid $alto;
        height: 30px;
        padding-left: 10px;
        margin-left: 10px;
        outline: none;
        color: $chicago;
      }
      &--selectSubtitle {
        color: $chicago;
        margin-left: 10px;
      }
      &--label {
        font-size: 16px;
        text-align: left;
        font-weight: bold;
        line-height: 20px;
        letter-spacing: 0em;
        font-family: $first_font;
      }

      &--input {
        width: 100%;
        height: 39px;
        border-radius: 4px;
        padding: 5px;
        border: 0.5px solid #a8a9a9;
        cursor: text;

        &::placeholder {
          padding: 0;
        }
      }

      &--inputPosition {
        width: 50px;
        height: 39px;
        border-radius: 4px;
        padding: 5px;
        border: none;
        border-bottom: 0.5px solid #a8a9a9;
        background-color: #ececec;
        text-align: center;
      }
    }

    &__btn {
      position: relative;
      text-align: center;
      top: -290px;
      left: 78%;

      .btnCreate {
        width: 30px;
        height: 30px;
        border: none;
        cursor: pointer;
        color: #fff;
        border-radius: 50%;
        background-color: $primary-color;

        .tooltiptext {
          top: 0px;
          left: 40px;
          opacity: 0.8;
          width: 150px;
          position: absolute;
          border-radius: 6px;
          visibility: hidden;
          padding: 3px 0 3px 5px;
          background-color: #000;

          &::after {
            content: "";
            top: 8px;
            left: -4px;
            border-width: 7px;
            margin-left: -10px;
            position: absolute;
            border-style: solid;
            border-color: transparent #000 transparent transparent;
          }
        }

        :nth-child(1) {
          margin-top: 3.5px;
        }

        &:hover {
          transform: scale(1.05);
          background: $primary_color;
          transition: all 0.3s ease-in-out;

          .tooltiptext {
            visibility: visible;
          }
        }
      }
    }

    .data-error {
      background: $primary_color;

      &::placeholder {
        color: #fff;
      }
    }

    &__btns {
      width: 100%;
      position: fixed;
      bottom: 0;
      display: flex;
      justify-content: center;
      gap: 15px;
      height: 70px;
      margin-left: -110px;
      padding: 20px 0;
      border: 1px solid #00000040;
      box-shadow: 0px 1px 4px 0px #00000040;
      background: #fff;

      &--cancel {
        border: 1px solid $primary_color;
        height: 35px;
        padding: 5px 10px;
        border-radius: 4px;
        color: #bd0909;
        cursor: pointer;
      }

      &--draft {
        border: 1px solid #bd090940;
        height: 35px;
        padding: 5px 10px;
        border-radius: 4px;
        background: #bd090940;
        color: #bd0909;
        cursor: pointer;
      }

      &--save {
        border: 1px solid #bd0909;
        height: 35px;
        padding: 5px 10px;
        border-radius: 4px;
        background: #bd0909;
        color: #fff;
        cursor: pointer;
      }
    }

    @media (min-width: 424px) {
      &__option {
        justify-content: flex-start;
      }
    }
    &__programmerHeader {
      @include Flex(row, space-between);
    }
    &__programmer {
      width: 100%;
      max-width: 1440px;
      height: 100%;
      margin: 1rem 0;
      border-radius: 6px;
      background-color: #fff;
      padding: 15px 20px 20px 20px;
      box-shadow: 0px 0.5px 4px 0px rgba(0, 0, 0, 0.25);
      &__allParticipants {
        display: flex;
        justify-content: flex-end;
        flex-wrap: wrap;
        &--toggle {
          display: flex;
          align-items: center;
          span {
            margin-right: 10px;
          }
          .toggleSwitch {
            margin-right: 10px;
          }
        }
      }
      &--seccion {
        width: 100%;

        @media (min-width: 1480px) {
          width: 25%;
        }
      }
      &--seccion--positions--button {
        margin-top: -15px;
        width: 70%;
        display: flex;
        justify-content: space-evenly;
        align-items: center;
      }
      &--line {
        margin-top: 15px;
        margin-bottom: 10px;
        height: 1px;
        border-bottom: 1px solid #d8d8d8;
      }
      &--podium {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        gap: 3%;
      }
      &--selectAmount {
        display: flex;
        justify-content: space-around;
        gap: 20px;
        position: relative;
        right: 20px;
        padding-top: 25px;
        .mycheck {
          width: 15px;
          height: 15px;
          padding: 9px;
          border-radius: 50%;
          border: solid 1.5px $chicago;
          &:checked {
            background-color: $primary-color;
            border-color: $primary-color;
          }
        }
      }
      &--option {
        display: flex;
        gap: 5px;
      }
      &--seccion--roles {
        width: 100%;
        display: flex;

        &__filtersApply {
          @include Flex(row, flex-start);
          margin-top: 0.5rem;
        }

        &__filtersApplyItem {
          display: flex;
          width: fit-content;
          margin-right: 1rem;
          padding: 0.2rem 0.6rem;
          color: $primary;
          font-weight: bold;
          border-radius: 1rem;
          background-color: rgba(242, 189, 189, 0.3);
        }

        &__filtersApplyIcon {
          font-size: 0.6rem;
          margin-left: 0.3rem;
          cursor: pointer;
        }
      }
      &--seccion--positions {
        display: flex;
        justify-content: space-between;
        width: 100%;

        &--label {
          width: 30%;
        }
      }
      &--title {
        font-size: 16px;
        font-weight: bold;
        text-align: left;
        line-height: 20px;
        letter-spacing: 0em;
        font-family: $primary-font;
      }
      &--subtitle {
        margin-top: 5px;
      }
      &--timer {
        gap: 2%;
        display: block;
        margin-top: 15px;

        @media (min-width: 768px) {
          display: flex;
        }
      }
      &--activate {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        margin-top: 20px;
        span {
          margin-right: 10px;
        }
      }
      &--calendar,
      &--clock {
        display: flex;
        gap: 10px;
        margin-bottom: 10px;
      }
      &--date {
        border: 1px solid #00000040;
        border-radius: 6px;
        height: 35px;
        width: 100%;
        padding: 0 10px;
      }
      &--time {
        border: 1px solid #00000040;
        border-radius: 6px;
        height: 35px;
        width: 100%;
        padding: 0 10px;
      }
      &__type {
        display: flex;

        &--headers {
          margin-bottom: 10px;
        }
        &--body {
          padding: 10px 0px;
          border-bottom: 1px solid #d8d8d8;
        }
        &--title {
          width: 60%;
        }
        &--internal {
          width: 20%;
          display: flex;
          justify-content: center;
        }
        &--internal.type--border {
          border-right: 1px solid #d8d8d8;
        }
        &--external {
          width: 20%;
          display: flex;
          justify-content: center;
        }
      }
    }
    &__rankingLimit {
      width: 80px;
      height: 35px;
      border-radius: $radius-4;
      padding: $space-4;
      border: 0.5px solid $border-inputs;
      text-align: center;
    }
    &__rankingTimes {
      margin-top: $space-8;
    }
    &__rankingTimesAdd {
      @include Flex(row, flex-start);
      gap: 10px;
      margin-bottom: $space-8;
    }
    &__rankingTimesDropdown {
      position: relative;
      width: 170px;
    }
    &__rankingTimesDropdownBtn {
      @include Flex(row, space-between);
      width: 100%;
      height: 35px;
      padding: 0 $space-8;
      border: 1px solid #00000040;
      border-radius: 8px;
      background: $white;
      font-size: 16px;
      color: $chicago;
      cursor: pointer;
      gap: $space-8;
    }
    &__rankingTimesDropdownList {
      position: absolute;
      top: calc(100% + #{$space-4});
      left: 0;
      width: 100%;
      max-height: 180px;
      overflow-y: auto;
      background: $white;
      border: 1px solid $alto;
      border-radius: 8px;
      z-index: 10;
      list-style: none;
      padding: 0;
      margin: 0;
      box-shadow: $shadow-little;
      &::-webkit-scrollbar {
        width: 4px;
      }
      &::-webkit-scrollbar-track {
        background: transparent;
      }
      &::-webkit-scrollbar-thumb {
        background: #d6d6d6;
        border-radius: $radius-4;
      }
    }
    &__rankingTimesDropdownItem {
      padding: $space-6 $space-12;
      font-size: 16px;
      cursor: pointer;
      &:hover {
        background-color: #f5f5f5;
      }
      &--placeholder {
        color: $button-disable;
      }
    }
    &__rankingTimesBtn {
      height: 35px;
      padding: $space-4 $space-12;
      border-radius: 8px;
      border: 1px solid $primary_color;
      color: $primary_color;
      background: $white;
      cursor: pointer;
      &:disabled {
        opacity: $opacity-button;
        border-color: #cccccc;
        color: #cccccc;
        cursor: not-allowed;
      }
    }
    &__rankingTimesList {
      @include Flex(row, flex-start);
      flex-wrap: wrap;
      gap: $space-8;
    }
    &__rankingTimesChip {
      @include Flex(row, space-between);
      gap: $space-8;
      padding: $space-4 $space-12;
      border-radius: $radius-20;
      background-color: #f5f5f5;
      color: #3d3d3d;
    }
    &__rankingTimesRemove {
      border: none;
      background: none;
      cursor: pointer;
      color: #3d3d3d;
      font-size: 18px;
      line-height: 1;
      padding: 0;
    }
    &__rankingTimesEmpty {
      color: $button-disable;
      font-style: italic;
      font-size: 13px;
    }
    &__policiesCompetitions {
      position: relative;
      padding: 1rem;
      overflow: hidden;
      border-radius: 10px;
      background: #fff;
      box-shadow: 0px 0.5px 4px 0px rgba(0, 0, 0, 0.25);
    }
    &__policiesCompetitionsHeader,
    &__policiesCompetitionsAllOption,
    &__policiesCompetitionsInfoMessage {
      @include Flex(row, space-between, center);
    }
    &__policiesCompetitionsAllOption,
    &__policiesCompetitionsInfoMessage {
      gap: $space-8;
    }
    &__policiesCompetitionsTitle {
      font-weight: bold;
      color: $primary;
    }
    @media (max-width: 570px) {
      &__programmer__allParticipants {
        margin: 10px 0;
      }
      &__toggle__section {
        @include Flex(flex, space-between);
        flex-direction: column;
        .toggle {
          margin-top: 20px;
        }
      }
      &__viewListParticipant {
        position: relative;
        margin-top: 25px;
        right: 100%;
      }
    }
    @media (max-width: 380px) {
      &__viewListParticipant {
        position: relative;
        margin-top: 40px;
        right: 80%;
      }
    }
    @media (max-width: 330px) {
      &__viewListParticipant {
        position: relative;
        margin-top: 40px;
        right: 60%;
      }
    }
  }
  @media (min-width: 768px) {
    .create__name--contestType {
      flex-direction: row;
      gap: 30px;
    }
  }

  .Vue-Toastification {
    &__toast {
      background-color: #ffff;
      max-height: 59px;
      min-height: 6px;
      padding: 16px 24px;
      &-body {
        color: #000;
      }
      &--success {
        .Vue-Toastification__icon {
          color: #4caf50;
        }
        .Vue-Toastification__close-button {
          color: #000;
        }
      }
      &--error {
        .Vue-Toastification__icon {
          color: $primary;
        }
        .Vue-Toastification__close-button {
          color: #000;
        }
      }
      &--info {
        .Vue-Toastification__icon {
          color: #efefef;
        }
        .Vue-Toastification__info-button {
          color: #000;
        }
      }
    }
  }
</style>
